module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAABT0lEQVR4Ae3cMUrDUBjA8R6hR8gJRDxBhw6OTgpOAaHgIMTBycEO3sDJySO4uvUWbpIj9AjxK2R6BD98DqL5Cf+lJcsPfOl7+cii5m9z99BF+2gY24+fLf5bNRe1I8pU8R2gfgrn5vZ+eL7Y9B9H623URk20+Ot9+4IpnKfL6+H95HSI78t20WrWQI9X3QEiq4/aWQK9rc9ToAJqGy1nAxSf1bQfoRpAeS9RAyjvNVoByttFLaAf3/kAlQv6ElACVSzogJI73zGgonQrAyhf0AHlUF20BFS7lQE0vZUBlNcByjsD9HU7QID8i1mk3eZ/Nz8UbTVsVh13ODBz5OrQ3mMfDw49eja8YPzFAFX1VsAIniFOQ5zFGPAByhhwiVNkkBwQIECAKgMECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAfKKrrEekJe85c3pNYGfHEaEw5YhgKMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f6a9.png
// module id = 1283
// module chunks = 0